<template>
  <v-card
    class="link.canAnswer ? 'fill-height text-left d-flex flex-column' : 'fill-height text-left d-flex flex-column dsfr'"
    outlined
    :href="link.canAnswer ? '/surveys/create/' + link.survey.slug : null"
  >
    <v-card-item>
      <v-card-title>
        {{ link.title ? link.title : link.survey.name }}
      </v-card-title>

      <v-card-subtitle>
        {{ link.canteen.name }}
      </v-card-subtitle>
    </v-card-item>

    <v-card-text>
      {{ link.survey.description }}
    </v-card-text>

    <v-spacer></v-spacer>
    <v-card-actions class="px-4 py-4">
      <v-spacer></v-spacer>
      <v-icon v-if="link.canAnswer" color="primary">$arrow-right-line</v-icon>
      <v-text v-else class="text-caption">Déjà répondu</v-text>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "SurveyLinkCard",
  props: {
    link: {
      type: Object,
      required: true,
    },
    headingLevel: {
      type: String,
      required: false,
    },
  },
  methods: {
    tagColor(tag) {
      const colours = [
        "pink lighten-4",
        "blue lighten-4",
        "green lighten-4",
        "purple lighten-4",
        "yellow lighten-4",
        "teal lighten-4",
      ]
      const colourIndex = Array.from(tag, (x) => x.charCodeAt(0)).reduce((a, b) => a + b) % (colours.length - 1)
      return colours[colourIndex]
    },
  },
  computed: {
    hLevel() {
      return this.headingLevel || "h2"
    },
  },
}
</script>

<style scoped>
ul {
  padding-left: 0;
  list-style-type: none;
}
/* https://developer.mozilla.org/en-US/docs/Web/CSS/list-style-type#accessibility_concerns */
li::before {
  content: "\200B";
}
</style>
